<mat-accordion [multi]="multi" displayMode="flat">
  <ng-content></ng-content>
</mat-accordion>
